<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <!-- 検索エリア -->
          <supplier-search-area />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import SupplierSearchArea from "../components/SupplierSearchArea.vue";

export default {
  name: "SupplierSearch",

  components: {
    SupplierSearchArea,
  },
  data: () => ({
  }),
  computed: {},
  methods: {
  },
};
</script>